"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("composer-lib/lib/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _UINotificationBadge = _interopRequireDefault(require("UIComponents/badge/UINotificationBadge"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _User = _interopRequireDefault(require("composer-lib/data/model/User"));

var COMMENTER_TO_IDLE_LOCKER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_IDLE_LOCKER,
    COMMENTER_TO_LOCKER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_LOCKER,
    REQUESTER_TO_LOCKER = _constants.PRESENCE_RELATIONSHIPS.REQUESTER_TO_LOCKER;

var _default = (0, _createReactClass.default)({
  displayName: "PresenceAvatar",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    dropdownOpen: _propTypes.default.bool.isRequired,
    prefix: _propTypes.default.string.isRequired,
    shortUserTitle: _propTypes.default.object.isRequired,
    toggleOpen: _propTypes.default.func.isRequired,
    tooltipPlacement: _propTypes.default.string.isRequired,
    user: _propTypes.default.instanceOf(_User.default).isRequired,
    withDropdown: _propTypes.default.bool.isRequired
  },
  getClassNamesForAvatar: function getClassNamesForAvatar() {
    var _this$props = this.props,
        dropdownOpen = _this$props.dropdownOpen,
        prefix = _this$props.prefix,
        withDropdown = _this$props.withDropdown;
    var editor = [COMMENTER_TO_LOCKER, COMMENTER_TO_IDLE_LOCKER].indexOf(prefix) > -1;
    return (0, _classnames.default)('fake-hoverlay', {
      'dropdown-open': dropdownOpen,
      editor: editor,
      'possibly-unlocked-from-idleness': prefix === COMMENTER_TO_IDLE_LOCKER,
      'with-dropdown': withDropdown
    });
  },
  renderAvatar: function renderAvatar() {
    var _this$props2 = this.props,
        toggleOpen = _this$props2.toggleOpen,
        user = _this$props2.user,
        withDropdown = _this$props2.withDropdown;
    var classNames = this.getClassNamesForAvatar();
    return _react.default.createElement("div", {
      className: classNames,
      onClick: withDropdown && toggleOpen
    }, _react.default.createElement("span", {
      className: "overlay"
    }), _react.default.createElement(_UIAvatar.default, {
      lookup: {
        type: 'hubSpotUserEmail',
        primaryIdentifier: user.email
      },
      size: "sm"
    }));
  },
  renderAvatarWithBadge: function renderAvatarWithBadge() {
    if (this.props.prefix === REQUESTER_TO_LOCKER) {
      return _react.default.createElement(_UINotificationBadge.default, {
        badgeDescription: "Editing access requested",
        className: "fake-hoverlay",
        placement: "inset",
        size: "small"
      }, this.renderAvatar());
    }

    return this.renderAvatar();
  },
  render: function render() {
    var _this$props3 = this.props,
        dropdownOpen = _this$props3.dropdownOpen,
        shortUserTitle = _this$props3.shortUserTitle,
        tooltipPlacement = _this$props3.tooltipPlacement,
        user = _this$props3.user;
    return _react.default.createElement(_UITooltip.default, {
      disabled: dropdownOpen,
      key: user.id,
      placement: tooltipPlacement,
      title: shortUserTitle
    }, this.renderAvatarWithBadge());
  }
});

exports.default = _default;
module.exports = exports.default;